"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const RatingStyled = (0, _styled.default)("div")`
    display: flex;
    flex-wrap: wrap;
    gap: var(--sds--rating--option--gap, 4px);
    // For the z-index: -1 on the hidden inputs.
    isolation: isolate;
    width: fit-content;
`;
exports.RatingStyled = RatingStyled;
//# sourceMappingURL=RatingStyled.js.map